import map from 'lodash/map';
import reduce from 'lodash/reduce';
import assign from 'lodash/assign';
import selectGameKeys from './select-game-keys';
import { selectBestScoreFraction } from './best-score';


const selectScoreCardDeception = ({ deception }, phrases) => {
  if (!deception) return null;

  const { summary, headings: { latestRound } } = phrases;
  const { stats, tellLabels, ...deceptionPhrases } = phrases.deception;

  // ideally should be coming from Contentful
  const mugs = {
    quiff: 'https://images.ctfassets.net/gtqjh9j40j4m/6Gidx4VZY1XghcT2d6pcdS/dcdadd58a97cf3a94684335b59a0e2bf/a-quiff-guy.png',
    turtle: 'https://images.ctfassets.net/gtqjh9j40j4m/2KWjeU4L7uLhLlI5xMYs4/75d3e220e6309b9266b721d41a2d6a46/b-turtle-neck.png',
    bald: 'https://images.ctfassets.net/gtqjh9j40j4m/4qBFyhBI50FLG6iId4kZUz/f27687016f404ba625cbd142c84ee694/c-bald-guy.png',
    lady: 'https://images.ctfassets.net/gtqjh9j40j4m/6Q2SPKpou4Q8MNEWBTsn8f/e5e224c381c7e8466eb5218d992b33ed/d-lady-curls-centred.png',
  };

  const v1Mughots = [mugs.quiff, mugs.turtle, mugs.bald, mugs.lady];
  const v2Mughots = [mugs.quiff, mugs.turtle, mugs.lady];

  const lyingSignsContent = [
    {
      tellKey: 'tell-pursed-lips',
      imgSrc: 'https://images.ctfassets.net/gtqjh9j40j4m/1W4Vwy4sh4w215p2ZS7BHe/c8c0d802b7c06dc2f46acaf1c1b1ade0/pursed-lips.jpg',
      tellLabel: tellLabels.pursedLips,
      questionIndex: 0,
    },
    {
      tellKey: 'tell-hand-to-nose',
      imgSrc: 'https://images.ctfassets.net/gtqjh9j40j4m/15EjL0FhYDuMqtDov8qGB1/a24287b64a1824b19ceb2d3ffcbe91a1/hand-to-nose-activity.png',
      tellLabel: tellLabels.handToNose,
      questionIndex: 1,
    },
  ];

  const imageUrl = 'https://images.ctfassets.net/gtqjh9j40j4m/7mT6PpXJ3kH77oC0Tfqd6U/ead807a1f2ef6b2618e838d4a54822f5/deception-player.jpg';
  const videoUrl = 'https://videos.ctfassets.net/gtqjh9j40j4m/2P2mGciSCyTLH3x3yF6FGo/71aa9c863ded775ef134739769f3eba0/deception2.mp4';

  const bestScore = selectBestScoreFraction(deception.games, 'score');
  const latestGame = deception.games[0];
  const { timesPlayed } = deception;
  const { score, observation, interrogation } = latestGame;

  const numberOfv2Suspects = 3;
  const observationSuspects = Object.keys(observation.correctAnswers).length;
  const suspectImagesContent = observationSuspects > numberOfv2Suspects ? v1Mughots : v2Mughots;

  const resultsArr = map(observation.results);
  const nullPadding = Array(observationSuspects).fill(null);
  const resultsWithUnanswered = assign(nullPadding, resultsArr);

  const observationResults = {
    suspects: map(resultsWithUnanswered, (mark, index) => ({
      imgSrc: suspectImagesContent[index],
      correct: mark,
    })),
  };

  const [liesSpotted, liesTotal] = reduce(
    observation.correctAnswers,
    (accum, curValue, curIndex) => ([
      accum[0] + ((curValue === false && resultsWithUnanswered[curIndex]) ? 1 : 0),
      accum[1] + (curValue ? 0 : 1),
    ]),
    [0, 0],
  );

  const observationSignsDetected = {
    tells: lyingSignsContent.filter(sign => resultsWithUnanswered[sign.questionIndex]),
  };

  const [smileCount, blinksCount] = reduce(
    interrogation.lieTells,
    (accum, curValue) => ([
      accum[0] + (curValue.tell === 'smile' ? 1 : 0),
      accum[1] + (curValue.tell === 'blink' ? 1 : 0),
    ]),
    [0, 0],
  );

  return {
    latestRound,
    imageUrl,
    videoUrl,
    observationResults,
    observationSignsDetected,
    summary: [
      {
        key: 'times-played',
        value: timesPlayed,
        units: null,
        descriptor: summary.timesPlayed,
      },
      {
        key: 'best-score',
        value: bestScore,
        units: summary.correctAnswers,
        descriptor: summary.bestScore,
      },
    ],
    statsInterrogation: {
      classNames: 'stat-pair stat-deception-interrogation',
      title: stats.signsDisplayed,
      titleClass: 'title',
      stats: [
        [smileCount, stats.smiles],
        [blinksCount, stats.blinks],
      ],
    },
    statsObservation: {
      classNames: 'stat-pair-space-between hero-stat',
      stats: [
        [stats.interrogation, score],
      ],
    },
    statsTell: {
      classNames: 'stat-pair-space-between hero-stat',
      stats: [
        [stats.signsIdentified, `${liesSpotted}/${liesTotal}`],
      ],
    },
    ...deceptionPhrases,
    ...selectGameKeys({ deception }),
  };
};

export default selectScoreCardDeception;
